var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner-body" }, [
      _c("div", { staticClass: "banner" }, [
        _c("img", {
          staticClass: "img",
          attrs: { src: "/images/judicialService/banner-img.png" }
        }),
        _c("div", { staticClass: "text-box" }, [
          _c("h1", { staticClass: "title" }, [
            _vm._v("解决文件签署后纠纷，服务电子签署最后一公里")
          ]),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "君子签，创新“区块链+司法+电子签署”模式，签署信息同步存证至司法机构，真正实现“即签”、“即存证 ”、“即公证”、“即仲裁”、“即变现”，解决文件签署后纠纷，服务电子签署最后一公里。"
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44e9187c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44e9187c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/judicialService/banner.vue
// module id = 0xpk
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37